import(/* webpackMode: "eager" */ "/home/ubuntu/html/tablespace-website/app/error.tsx");
